export default __webpack_public_path__ + "static/media/LockImage.45baea14.svg";